import { Grid, Typography } from "@mui/material";
import Appointment from "../interface/appointment";
import transformDateToDe from "../../../functions/transformDateToDe";

const RenderTimeSlot = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={3}
    sx={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <Typography variant="body1" color="initial">
      {`${transformDateToDe(appointment.date)} - ${appointment.timeSlot}`}
    </Typography>
  </Grid>
);

export default RenderTimeSlot;
